module.exports = __webpack_public_path__ + "img/common-file-text-add.519f2a02.svg";